import React, { useEffect, useState } from 'react'
import Header from './header'
import { Outlet } from 'react-router-dom'
import { Sidebar } from './sidebar'
import { Footer } from './footer'
import AuthUser from './Auth'
import { useLocation } from 'react-router-dom';

export const DashLayout = () => {
    const [isSidebarClosed, setIsSidebarClosed] = useState(window.innerWidth < 992);
    const location = useLocation();
    // const toggleSidebar = () => {
    //     setIsSidebarClosed(!isSidebarClosed);
    // };
    const toggleSidebar = () => {
        setIsSidebarClosed(prev => !prev);
    };

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) {
                setIsSidebarClosed(true);
            } else {
                setIsSidebarClosed(false);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
    if (window.innerWidth < 768) {
        setIsSidebarClosed(true);
    }
}, [location]);
    return (
        <div className="page-wrapper compact-wrapper" id="pageWrapper">
            <AuthUser />
            <div className={`page-header ${isSidebarClosed ? 'close_icon' : ''}`}>
                <Header toggleSidebar={toggleSidebar} />
            </div>
            <div className="page-body-wrapper">
            <Sidebar isClosed={isSidebarClosed} toggleSidebar={toggleSidebar} />
                

                <div className="page-body">
                    <Outlet />
                </div>
                <Footer />
            </div>
        </div>
    )
}
